import React from 'react'
import classNames from 'classnames'

import { BaltoGPTIcon } from '../icons/BaltoGPTIcon'

import './BaltoGPTButton.scss'

export const BaltoGPTButton = ({ handleToggleChatVisible, flush }) => {
  return (
    <button
      type="button"
      className={classNames('balto-gpt-button', { flush })}
      onClick={handleToggleChatVisible}
      data-testid="balto-gpt-button"
    >
      <BaltoGPTIcon />
    </button>
  )
}
